// getters
const papeleriaReports = state => state.papeleriaReports

export default {
  papeleriaReports
}



// WEBPACK FOOTER //
// ./src/store/modules/papeleria/reports/getters.js